import React, {useMemo} from "react"
import ProductsGrid from "../components/ProductsGrid"
import ProductCard from "../components/ProductCard"
import ProductsHeader from "../components/ProductsHeader"
import {useStoreProductsQuery} from "@irati/payrollpay/hooks"
import Spinner from "@irati/ui/src/Loading/Spinner"
import {useStoreContext} from "../context/StoreContext"

const ProductsScreen = () => {
  const {schemeType} = useStoreContext()
  const params = new URLSearchParams(window.location.search)
  const categories = params.get("categories")
  const departments = params.get("departments")
  const subcategories = params.get("subcategories")
  const filters = useMemo(() => {
    return {
      brands: [],
      promo: [],
      departments: departments ? [departments?.toString()] : [],
      categories: categories ? [categories?.toString()] : [],
      subcategories: subcategories ? [subcategories?.toString()] : [],
      minPrice: null,
      maxPrice: null,
      search: null,
      bg: null
    }
  }, [departments, categories, subcategories])

  const {data, load} = useStoreProductsQuery(
    {
      organisationId: "566-zz-nhs-demo",
      locale: "en-GB",
      schemeType,
      filters,
      page: 1,
      productsPerPage: 40,
      orderBy: ""
    },
    {
      fetchPolicy: "cache-and-network"
    }
  )

  const loading = load?.loading

  if (loading) {
    return <Spinner />
  }

  const products = data?.employeeOrganisation?.scheme?.store?.products
  return (
    <>
      <ProductsHeader />
      <ProductsGrid>
        {products &&
          products.map(({name, image, price, term, productTagImage, productId, url}) => (
            <ProductCard
              key={productId}
              name={name}
              image={image ?? ""}
              price={price}
              term={Number(term) || ""}
              productTagImage={productTagImage ?? ""}
              url={url ?? ""}
            />
          ))}
      </ProductsGrid>
    </>
  )
}

export default ProductsScreen
